import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';
import { RippleModule } from 'primeng/ripple';
import { AppConfigModule } from './config/app.config.module';
import { AppLayoutComponent } from './app.layout.component';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { AppSidebarComponent } from './components/app-sidebar/app.sidebar.component';
import { AppTopbarComponent } from './components/app-topbar/app.topbar.component';
import { AppProfileSidebarComponent } from './profile/app.profile-sidebar.component';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuitemComponent } from './components/app-menuitem/app.menuitem.component';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AppLogoComponent } from './components/app-logo/app.logo.component';
import { WizardLayoutComponent } from './wizard-layout/wizard-layout.component';
import { WizardTopbarComponent } from './wizard-layout/components/wizard-topbar/wizard-topbar.component';
import { IonicModule } from '@ionic/angular';
import { AvatarModule } from 'primeng/avatar';
import { ListItemSimpleDataComponent } from '../shared/components/list-items/list-item-simple-data/list-item-simple-data.component';
import { SimpleSidebarComponent } from '../shared/components/simple-sidebar/simple-sidebar.component';
import { OmsCardComponent } from '../shared/components/oms-card/oms-card.component';
import { AppProfileEditSidebarComponent } from './profile/components/app.profile-sidebar-edit/app.profile-sidebar-edit.component';
import { InputErrorDirective } from '../shared/directives/input-with-error.directive';
import { OmsGlassBackgroundComponent } from '../shared/components/oms-glass-background/oms-glass-background.component';
import { CommonModule } from '@angular/common';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { NotificationsPopoverComponent } from '../shared/components/notifications-popover/notifications-popover.component';

@NgModule({
  declarations: [
    AppLayoutComponent,
    WizardLayoutComponent,
    WizardTopbarComponent,
    AppBreadcrumbComponent,
    AppSidebarComponent,
    AppTopbarComponent,
    AppProfileSidebarComponent,
    AppProfileEditSidebarComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    AppLogoComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    InputTextModule,
    SidebarModule,
    BadgeModule,
    RadioButtonModule,
    InputSwitchModule,
    ButtonModule,
    TooltipModule,
    RippleModule,
    RouterModule,
    AppConfigModule,
    IonicModule,
    AvatarModule,
    ListItemSimpleDataComponent,
    SimpleSidebarComponent,
    OmsCardComponent,
    ReactiveFormsModule,
    InputErrorDirective,
    OmsGlassBackgroundComponent,
    CommonModule,
    OverlayPanelModule,
    NotificationsPopoverComponent,
  ],
})
export class AppLayoutModule {}
